"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const branding_1 = require("src/context/branding");
const layout_1 = require("src/hooks/layout");
const question_1 = __importDefault(require("../question"));
const question_rating_star_configs_1 = require("./question-rating-star-configs");
const question_rating_star_1 = __importDefault(require("./question-rating-star"));
const question_rating_styles_1 = __importDefault(require("./question-rating.styles"));
const question_rating_feedback_demo_styles_1 = __importDefault(require("./question-rating-feedback-demo.styles"));
const b = b_1.default.with('rating');
// eslint-disable-next-line complexity, max-statements
function Rating(props) {
    var _a, _b;
    const { handleClickOption, id, options, children, feedbackDemoMode } = props, rest = __rest(props, ["handleClickOption", "id", "options", "children", "feedbackDemoMode"]);
    const isMobile = (0, layout_1.useIsMobile)();
    const branding = (0, branding_1.useBrandingContext)();
    const isMany = isMobile && options.length >= 7;
    const { rating: { starType = 'default' } = {} } = branding || {};
    const starConfigBlock = question_rating_star_configs_1.STAR_CONFIGS[starType] || question_rating_star_configs_1.STAR_CONFIGS.default;
    const starConfig = starConfigBlock[isMany ? 'many' : 'few'] || starConfigBlock.few;
    const indexSelected = (_b = (_a = options.find(opt => opt.checked)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1;
    const styles = [question_rating_styles_1.default];
    if (feedbackDemoMode)
        styles.push(question_rating_feedback_demo_styles_1.default);
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: styles }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b({
                    stars: options.length,
                    isMany,
                    starType
                }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('container'), role: 'radiogroup' }, { children: options.map((option, index) => {
                        const starId = `q${id}op${option.id}`;
                        return ((0, jsx_runtime_1.jsx)(question_rating_star_1.default, { option: option, starConfig: starConfig, active: indexSelected > index, questionId: id, handleClickOption: handleClickOption }, starId));
                    }) })) })), children] })));
}
exports.default = Rating;
Rating.defaultProps = {
    handleClickOption: () => { },
    options: [],
    id: 0,
    handleClickNoOpinionAnswer: () => { },
    noOpinionAnswer: {
        enabled: false,
        label: '',
        checked: false
    },
    children: [],
    feedbackDemoStyles: false
};
